import { useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useActiveOrganization } from "@/hooks/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface CancelSubscriptionRequest {
  organization_id: number;
}

export interface CancelSubscriptionResponse {
  success: boolean;
  message: string;
  old_plan?: string;
  new_plan?: string;
  canceled_at?: string;
}

export const useCancelSubscription = () => {
  const userToken = useAuth()?.userToken ?? "";
  const activeOrganization = useActiveOrganization();
  return useMutation({
    mutationFn: async (): Promise<CancelSubscriptionResponse> =>
      fetch(ENDPOINTS.billing.cancel_subscription, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          organization_id: activeOrganization.data?.id,
        }),
      }).then(handleResponse),
    onSuccess: () => {
      window.location.reload();
    },
  });
};
